import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import api from '../../api';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  const [policy, setPolicy] = useState({
    title: 'Privacy Policy',
    content: '',
    lastUpdated: null,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPolicy();
  }, []);

  const handleClose = () => {
    try {
      const hasHistory = window.history.length > 1;
      const hasSameOriginReferrer =
                document.referrer &&
                new URL(document.referrer).origin === window.location.origin;
      if (hasSameOriginReferrer || hasHistory) {
        navigate(-1);
      } else {
        navigate('/'); // fallback to home if opened from email/new tab
      }
    } catch {
      navigate('/');
    }
  };

  const fetchPolicy = async () => {
    try {
      const response = await axios.get(api.getPolicyContent('privacy-policy'));
      if (response.data.exists) {
        setPolicy({
          title: response.data.title || 'Privacy Policy',
          content: response.data.content || '',
          lastUpdated: response.data.lastUpdated,
        });
      } else {
        setPolicy({
          title: 'Privacy Policy',
          content: 'Privacy Policy content will be available soon.',
          lastUpdated: null,
        });
      }
    } catch (error) {
      console.error('Error fetching privacy policy:', error);
      setPolicy({
        title: 'Privacy Policy',
        content: 'Unable to load privacy policy. Please try again later.',
        lastUpdated: null,
      });
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'Not available';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  };

  if (loading) {
    return (
      <div className="pp-container">
        <button
          type="button"
          className="pp-close-btn"
          onClick={handleClose}
        >
                    ×
        </button>
        <div style={{ textAlign: 'center', padding: '2rem' }}>
          <p>Loading Privacy Policy...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="pp-container">
      <button
        type="button"
        className="pp-close-btn"
        aria-label="Close Privacy Policy"
        title="Close"
        onClick={handleClose}
      >
                ×
      </button>
      <h1 className="pp-heading">{policy.title}</h1>
      <p className="pp-date">Last updated: {formatDate(policy.lastUpdated)}</p>

      <div 
        className="pp-content"
        dangerouslySetInnerHTML={{ __html: policy.content || 'Privacy Policy content will be available soon.' }}
      />
    </div>
  );
};

export default PrivacyPolicy;
